import { useEffect } from "react";

import { Box, Card, CardBody, Grid, Heading, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { useAppState } from "~/hooks/useAppState";

const SuperuserPage = () => {
  const { userInfo } = useAppState("userInfo");
  const navigate = useNavigate();

  // Protected route check - redirect to 404 if not a superuser
  useEffect(() => {
    if (userInfo && !userInfo.isSuperAdmin) {
      navigate("/not-found", { replace: true });
    }
  }, [userInfo, navigate]);

  // Only render page content if user is a superuser
  if (!userInfo?.isSuperAdmin) return null;

  return (
    <Box maxW="1200px" mx="auto" p={5}>
      <VStack spacing={8} align="stretch">
        <Heading as="h1" size="xl" mb={2}>
          Superuser Dashboard
        </Heading>
        <Text mb={6}>Welcome to the superuser dashboard. This page is only accessible to superusers.</Text>

        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap={6}>
          <Card>
            <CardBody>
              <Heading as="h3" size="md" mb={3}>
                User Management
              </Heading>
              <Text>Manage users, permissions, and access control.</Text>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Heading as="h3" size="md" mb={3}>
                System Settings
              </Heading>
              <Text>Configure application-wide settings and defaults.</Text>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Heading as="h3" size="md" mb={3}>
                Audit Logs
              </Heading>
              <Text>View system activity and monitor for security issues.</Text>
            </CardBody>
          </Card>
        </Grid>
      </VStack>
    </Box>
  );
};

export default SuperuserPage;
